export default __webpack_public_path__ + "static/social_wanderflower-476c7f87824ccf983cf426052e1106ba.png";